__webpack_require__.p = "https://spellbit.sgp1.cdn.digitaloceanspaces.com/_next/";